import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import MainFooter from "../components/layout/MainFooter";

const Blank = ({ children, noNavbar, noFooter }) => {
  console.log(children);
  return (
    <Container fluid>
      <Row>
          {children}
      </Row>
    </Container>
  );
};

Blank.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool,
};

Blank.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default Blank;
